import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
  },

  contentWrapper: {
    marginTop: 30,
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 0,
    columnGap: 10,
    marginTop: 20,
  },
  gridItemTitle: {
    color: '#27343d',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.4,
    marginBottom: 4,
  },
  gridItemText: {
    color: '#27343d',
    fontSize: 12,
    lineHeight: 1.4,
  },
  customGridContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: 10,
  },
  gridColumn: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '32%',
  },
  gridItem: {
    marginBottom: 20,
    fontFamily: 'Lato',
  },

  // Images section
  imageSection: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 500,
    marginBottom: 20,
  },
  leftImageColumn: {
    width: '60%',
    marginRight: '4%',
  },
  rightImageColumn: {
    width: '36%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  largeImage: {
    width: 360,
    height: 500,
    objectFit: 'cover',
    borderRadius: '5px',
  },
  smallImageTop: {
    height: 195,
    objectFit: 'contain',
    borderRadius: '5px',
  },
  smallImageSpacer: {
    height: 27,
  },
  smallImageBottom: {
    width: '100%',
    height: 215,
    objectFit: 'cover',
    borderRadius: '5px',
  },
  rightColumnText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1.27,
  },
});
